import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Media } from 'react-breakpoints'
import {
  Tooltip,
  OverlayTrigger,
  Modal,
  Row,
  Col,
  Accordion,
  useAccordionButton as useAccordionToggle,
  ProgressBar,
} from 'react-bootstrap'
import { Td, Tr } from 'react-super-responsive-table'
import {
  CustomFilter,
  Button,
  Icon,
  Card,
  FormText,
  CustomDate,
  Switch,
  IconImg,
  Title,
  Select,
  Checkbox,
  TableV2,
  Commentary,
} from 'src/components'
import Alert from 'sweetalert-react'

import WarehouseService from '../../../services/warehouse.service'

import {
  faWindowClose,
  faPlus,
  faSave,
  faArrowRight,
  faTrash,
  faMinus,
  faPlusSquare,
  faEdit,
  faComment,
  faPlusCircle,
  faBarcode,
  faKeyboard,
  faArrowUp,
} from '@fortawesome/free-solid-svg-icons'

import { loadingSelector } from '../../../selectors/loading.selector'
import {
  selectCompanyField,
  selectCompanyIsLimit,
  selectSetCurrentCompany,
  selectCompanyFieldById,
} from '../../../selectors/company.selector'
import {
  selectInventoryWithPrices,
  selectWarehouseLite,
} from '../../../selectors/warehouse.selector'
import {
  selectCurrentCompany,
  selectCurrentModule,
} from '../../../selectors/user.selector'

import {
  actionTypes as actionW,
  actionTypes,
  getExistenceSingleWarehouseWithPriceProducts,
  getInventoryWithPrices,
  setInventoryList,
} from '../../../actions/warehouse.actions'
import { formatDateFromMillis, formatNumberWithCommas } from '../../../utils/formatters'
// import {useAccordionToggle} from "react-bootstrap/AccordionToggle";
import { handlerError } from '../../../selectors/error.selector'
import { isAllowed } from '../../../selectors/modules.selector'

import holder from '../../../assets/images/svg/food.svg'

import ItemCRUD from 'src/content/Products/ItemCRUD'

import CSVLoader, { CATEGORY_UPLOAD } from '../../../components/CSVLoader/CSVLoader'
import { loadProducts } from '../../../actions/purchase.actions'

import CustomCreate from '../../../components/inputs/Creable/CustomCreate'
import { useLocation } from 'react-router-dom'
import Money from '../../../components/Money/Money'
import { capitalizeString, getExchangeRate, toMoney } from '../../../utils/utilities'
import { selectCurrentCurrency } from '../../../selectors/currencies.selector'

import { getTipsAvailable } from '../../../actions/restaurant.actions'
import { selectDiscounts } from '../../../selectors/restaurant.selector'
import { getAllCurrencies } from '../../../actions/currencies.actions'

function RenderItems({
  eventKey,
  item,
  onEdit,
  onAction,
  toAssign,
  blockDiscount,
  mobile,
  type,
  importation,
  conversion,
  currentCurrency,
  activateLocalCurrency,
  exchangeRate,
}) {
  const decoratedOnClick = useAccordionToggle(eventKey, () => undefined)
  return (
    <li
      key={eventKey}
      style={{ padding: 0, 'list-style': 'none' }}
      id={`p-${item.productId}`}>
      <div className="b-item">
        <div className="space-between">
          {item.url && <IconImg imgStyle={{ width: 50, height: 45 }} icon={item.url} />}
          <div
            className="justify-content-start align-items-start bu-en"
            onClick={() => {
              decoratedOnClick()
            }}
            style={{ textAlign: 'left', marginTop: 4 }}>
            <div className={'b-user-name'}>
              {item ? `${item.productCode} ${item.productName}` : ''}
            </div>
            {type === serviceType.ORDERS && (
              <>
                <Money className={'b-user-email'}>{`Precio: ${
                  item
                    ? item.selectedPrice
                      ? item.selectedPrice.value
                      : item.productPrice
                    : ''
                }`}</Money>
                {type === serviceType.ORDERS && !item.includeIva && item.quantity && (
                  <div className={'b-user-email'} style={{ color: 'red' }}>
                    Precio sin IVA
                  </div>
                )}
              </>
            )}
            {!toAssign &&
              (type === serviceType.PURCHASE || type === serviceType.EXPENSES) && (
                <div className={'b-user-email'}>{`Precio Unitario: ${
                  activateLocalCurrency ? exchangeRate.symbol : '$'
                }. ${formatNumberWithCommas(
                  (item.subTotal || 0) / (item.quantity || 1),
                )}`}</div>
              )}
            {toAssign && (
              <div className={'b-user-email'}>{`Existencia: ${
                item
                  ? formatNumberWithCommas(
                      item.teoricExistence
                        ? item.productTeoricalExistence
                        : item.productExistence || 0,
                    )
                  : ''
              } U.`}</div>
            )}
          </div>
          <div className={'align-items-center'}>
            {!toAssign && (
              <div className={'b-user-email'}>{`${formatNumberWithCommas(
                item && (item.realQuantity || item.quantity),
              )} U.`}</div>
            )}
            {!toAssign && (
              <div className={'b-user-email'}>{`${
                activateLocalCurrency ? exchangeRate.symbol : '$'
              }.${item ? formatNumberWithCommas(item.subTotal) : ''}`}</div>
            )}
          </div>
          <div
            className={'d-flex row align-items-center mr-2 bu-b'}
            style={{ textAlign: 'right' }}>
            <Row
              className="no-margins"
              style={{ paddingBottom: 2, marginTop: 8, justifyContent: 'flex-end' }}>
              {!toAssign && (
                <Button
                  color={'secondary'}
                  onClick={() => onEdit(item)}
                  style={{ margin: 0 }}>
                  <Icon tooltip={'Editar el producto de la orden'} icon={faEdit} />
                </Button>
              )}
              <Button
                color={'accent'}
                style={{ margin: 0, marginLeft: 5 }}
                onClick={() => onAction(item, toAssign)}>
                <Icon
                  tooltip={toAssign ? 'Agregar' : 'Descartar'}
                  icon={toAssign ? (mobile ? faPlus : faArrowRight) : faTrash}
                />
              </Button>
            </Row>
          </div>
        </div>
      </div>
      <Accordion.Collapse eventKey={eventKey}>
        <div className={'pi-more'} style={{ paddingLeft: 15, paddingBottom: 5 }}>
          {!toAssign && type === serviceType.ORDERS && (
            <div>
              <Money className={'b-user-email'}>{`Subtotal sin descuento: ${
                item.discount ? toMoney(item.subTotal + Number(item.discount)) : 0
              }`}</Money>
              {item.subProductData && (
                <>
                  <Money className={'b-user-email'}>{`Subtotal ${item.productName}: ${
                    item.subTotal - item.subPrice + Number(item.discount || 0)
                  }`}</Money>
                  <Money
                    className={
                      'b-user-email'
                    }>{`Subtotal ${item.subProductData.name}: ${item.subPrice}`}</Money>
                </>
              )}
              {!(blockDiscount && blockDiscount.value === 'true') && (
                <Money className={'b-user-email'}>{`Descuento: ${toMoney(
                  item.discount ? item.discount : 0,
                )}`}</Money>
              )}
              <div className={'b-user-email'}>{`Comentario: ${
                item.commentary || ''
              }`}</div>
              {!item.includeIva && (
                <>
                  <div className={'b-user-email'}>
                    {item.phraseReference ? item.phraseReference.label : ''}
                  </div>
                </>
              )}
            </div>
          )}
          {!toAssign && type === serviceType.PURCHASE && (
            <div>
              <div
                className={'b-user-email'}>{`Fecha de Vencimiento: ${formatDateFromMillis(
                item.expirationDate ? item.expirationDate.valueOf() : null,
              )}`}</div>
              {importation && (
                <>
                  <div className={'b-user-email'}>
                    {`Tasa de impuestos: ${
                      activateLocalCurrency ? exchangeRate.symbol : '$'
                    }.${formatNumberWithCommas(item.tax)}`}
                  </div>
                  <div className={'b-user-email'}>{`Total en ${
                    currentCurrency.symbol
                  }.: ${
                    item
                      ? formatNumberWithCommas(
                          item.customPrice ||
                            formatNumberWithCommas(
                              (Number(item.subTotal) + Number(item.tax || 0)) *
                                conversion,
                            ),
                        )
                      : ''
                  }`}</div>
                </>
              )}
              {item.active &&
                item.series.map((p, i) => (
                  <div className={'b-user-email'} key={i}>
                    <FormText
                      label={'Número de serie unidad No.' + (i + 1)}
                      value={p}
                      disabled
                    />
                  </div>
                ))}
            </div>
          )}
        </div>
      </Accordion.Collapse>
    </li>
  )
}

let interval = null

const SelectProducts = ({
  show,
  onHide,
  modal,
  onSave,
  client,
  type,
  importation,
  loading,
  details,
  oWarehouse,
  order,
  balancesPermission,
}) => {
  const dispatch = useDispatch()

  const maxDiscount = useSelector(state => selectCompanyFieldById(state, 89))
  const blockDiscount = useSelector(selectCompanyField)
  const currentCurrency = useSelector(selectCurrentCurrency)

  const warehouses = useSelector(selectWarehouseLite)
  const loadingW = useSelector(state =>
    loadingSelector([actionW.GET_WAREHOUSE_LITE])(state),
  )

  const currentCompany = useSelector(selectCurrentCompany)
  const company = useSelector(selectSetCurrentCompany)
  const module = useSelector(selectCurrentModule)
  const isLimit = useSelector(selectCompanyIsLimit)
  const fieldRepeat = useSelector(state => selectCompanyFieldById(state, 105)) === 'true'

  const inventoryResponse = useSelector(selectInventoryWithPrices)
  const loadingInventory = useSelector(state =>
    loadingSelector([actionTypes.GET_INVENTORY_WITH_PRICE])(state),
  )

  const multiplePrices = useSelector(state => isAllowed(state, [1131]))
  const savePrice = useSelector(state => isAllowed(state, [1132]))
  const allowDisableIva = useSelector(state => isAllowed(state, [1133]))
  const phrases = useSelector(state =>
    Object.assign(
      [],
      state.resolutions.phrases.map(p => ({ ...p, label: p.phrase, value: p.id })),
    ),
  )

  const [isEdit] = useState(useLocation().pathname.includes('/editar'))

  const [inventory, setInventory] = useState([])
  const [loadingSearch, setLoadingSearch] = useState(false)

  const [action, setAction] = useState({ get: false, open: false })
  const [showIVA, setShowIVA] = useState(false)
  const [selected, setSelected] = useState([])
  const [searchA, setSearchA] = useState(null)
  const [searchB, setSearchB] = useState(null)
  const [mobile, setMobile] = useState(false)
  const [alert, setAlert] = useState({ title: '' })
  const [warehouse, setWarehouse] = useState({ value: null, label: 'Sin seleccionar' })
  const [toSelect, setSelect] = useState({})
  const [filters, setFilters] = useState({
    consigned: false,
    own: true,
    inactive: false,
    withoutContract: false,
    withoutExistence: false,
  })
  const [conversion, setConversion] = useState(7.6)
  const [error, setError] = useState(null)
  const [cpShow, setCPShow] = useState(false)
  const [productId, setProductId] = useState(0)
  const [store, setStore] = useState(false)
  const [listP, setList] = useState('')
  const [barcodeValue, setBarcodeValue] = useState(false)

  const [taxFree, setTaxFree] = useState(false)

  const currenciesOwn = useSelector(state =>
    Object.assign(
      [],
      state.currencies.allCurrencies.map(c => ({
        ...c,
        label: capitalizeString(`${c.name} (${c.code})`),
        value: c.id,
        symbol: c.symbol,
      })),
    ),
  )
  const [exchangeRate, setExchangeRate] = useState(
    currenciesOwn.find(c => c.code === currentCurrency.code),
  )
  const [activateLocalCurrency, setActivateLocalCurrency] = useState(false)
  const [localCurrency, setLocalCurrency] = useState(false)

  const [discountAll, setDiscountAll] = useState(false)
  const [discount, setDiscount] = useState(null)
  let sumDiscount = 0
  const [isGeneral, setIsGeneral] = useState(false)
  const discountsS = useSelector(selectDiscounts)
  const [discounts, setDiscounts] = useState([])

  useEffect(() => {
    setExchagneRateCurrency()
  }, [currenciesOwn])

  const setExchagneRateCurrency = () => {
    if (exchangeRate === undefined && currenciesOwn.length > 0) {
      setExchangeRate(currenciesOwn.find(c => c.code === 'GTQ'))
      let money = getExchangeRate(currentCurrency.code)
      if (money) setConversion(Number(money.exchange))
    }
  }

  useEffect(() => {
    dispatch(getTipsAvailable(null))
    dispatch(getAllCurrencies())
    if (type === serviceType.PURCHASE || type === serviceType.EXPENSES) {
      setWarehouse({ value: company.warehouse, label: 'Mi bodega' })
    }
  }, [])

  useEffect(() => {
    if (discountsS.length > 0) {
      setDiscounts(
        discountsS.map(x => {
          return { label: x.percentage + '%  ' + x.alias, value: x.percentage }
        }),
      )
    }
  }, [discountsS])

  useEffect(() => {
    if (show) {
      setAction({ ...action, open: true })
    }
  }, [show])

  useEffect(() => {
    if (!modal && selected.length > 0)
      onSave(selected, importation ? conversion : warehouse, localCurrency)
  }, [selected])

  useEffect(() => {
    if (client && client.id > 0) {
      let w = warehouses
      if (w.length > 0 && !warehouse.value) setWarehouse({ ...w[0] })
      else if (warehouse.value) {
        // dispatch(getInventoryWithPrices(warehouse.value, client.latitude, client.longitude, false, type, filters.withoutExistence, "120600400"));
      }
    }
  }, [client])

  useEffect(() => {
    if (selected.length === 0 && details && details.length > 0) {
      setStore(true)
      let list = ''
      if (isEdit) {
        details.map(d => {
          if (d.product) list += d.product.id + ','
        })
      } else {
        details.map(d => {
          if (d.productId) list += d.productId + ','
        })
      }
      list = list.slice(0, list.length - 1)
      setList(list)

      if (oWarehouse && oWarehouse.value !== warehouse.value) {
        setWarehouse(oWarehouse)
      }

      /*
      dispatch(
        getInventoryWithPrices(
          warehouseId,
          client ? client.latitude : 14.55,
          client ? client.longitude : -90.55,
          false,
          type,
          filters.withoutExistence,
          null,
          true,
          list,
        ),
      ) */
    }
  }, [details])

  useEffect(() => {
    if (
      productId > 0 &&
      (type === serviceType.EXPENSES || type === serviceType.PURCHASE)
    ) {
      let products = getOptions(inventory)
      let item = products.find(p => p.value === productId)
      if (item) {
        selected.push(item)
        setSelected([...selected])
      }
      setProductId(0)
    } else if (type === serviceType.ORDERS) {
      // TODO, crear un servicio que regrese los "Inventory" de los productos que componen la venta
      // TODO: el servicio se debe consumir al iniciar la pantalla de edición
      // TODO: podria hacerce un unico servicio para obtener los 10 mas vendidos o los de la venta con un query param
      if (store) {
        let products = getOptions(inventory)
        details.map((d, index) => {
          let exists =
            selected.filter(s => s.id === (isEdit ? d.product.id : d.productId)).length >
            0
          if (!exists) {
            let item = products.find(
              p => p.value === (isEdit ? d.product.id : d.productId),
            )
            if (item) {
              selected.push({
                ...item,
                realQuantity: d.realQuantity,
                quantity: d.quantity,
                sQuantity: d.sQuantity,
                discount: d.discount || 0,
                subTotal: d.subTotal,
                phraseReference: d.phraseReference,
              })
              changeQuantity(d.quantity, selected[index], false)
            }
          }
        })
        setStore(false)
      }
    } else if (type === serviceType.PURCHASE || type === serviceType.EXPENSES) {
      // TODO, crear un servicio que regrese los "Inventory" de los productos que componen la venta
      // TODO: el servicio se debe consumir al iniciar la pantalla de edición
      // TODO: podria hacerce un unico servicio para optener los 10 mas vendidos o los de la venta con un query param
      if (store) {
        let products = getOptions(inventory)
        details.map(d => {
          let exists = selected.filter(s => s.id === d.productId).length > 0
          if (!exists) {
            let item = products.find(p => p.value === d.productId)
            if (item) {
              selected.push({
                ...item,
                quantity: d.quantity,
                discount: 0,
                subTotal: d.price * d.quantity,
              })
            }
          }
        })
        setStore(false)
      }
    }
  }, [inventory])

  useEffect(() => {
    if (warehouse.value) {
      console.log('ES LA BODEGA')
      dispatch(
        getInventoryWithPrices(
          warehouse.value,
          client?.latitude,
          client?.longitude,
          false,
          type,
          filters?.withoutExistence,
          null,
          true,
          listP,
        ),
      )
      //setSelected([])
    }
  }, [warehouse.value])

  useEffect(() => {
    if (loadingInventory) setAction({ ...action, get: true })
    else if (action.get) {
      setAction({ ...action, get: false })
      let items = formatInventory(inventoryResponse)
      setInventory(items)
      dispatch(setInventoryList(items))
      setBarcodeValue(false)

      if (barcodeValue && items && items.length > 0) {
        let item = items[0]
        let findIndex = selected.findIndex(s => s.value === item.productId)
        let quantity = 1
        if (findIndex === -1) {
          findIndex = selected.length
          item.label = item.productName
          item.value = item.productId
          item.list.map(s => {
            if (s.price === item.productPrice) item.selectedAlias = s.alias
          })
          selected[findIndex] = item
        } else quantity = selected[findIndex].quantity + 1

        changeQuantity(quantity, selected[findIndex], false)
      }
    }
  }, [loadingInventory])

  const formatInventory = values => {
    const data = values
      ? values.filter(v => v?.inventory?.productCode !== 'P-CMSNGNC')
      : []
    if (!data) return []
    return data.map(i => {
      const { inventory, amounts } = i
      const { productPrice, productCompanyId, productActive } = inventory

      inventory.contract = true
      inventory.prices = []
      inventory.discountLimit = true

      let setting = {
        checked: false,
        realQuantity: 0,
        subTotal: 0,
        maxDiscount: 0,
        quantity: 0,
        discount: 0,
        sQuantity: 0,
      }

      if (!productActive) {
        inventory.error = 'El producto esta inactivo'
        inventory.disabled = true
      } else if (productCompanyId === currentCompany) {
        inventory.discountLimit = false
        inventory.prices.push({
          amount: productPrice,
          minimum: 0,
          maximum: 1000000,
          price: productPrice,
        })
      } else if (amounts.length === 0) {
        inventory.error = 'No se ha encontrado contrato de transporte para este producto.'
        inventory.disabled = true
        inventory.contract = false
      } else {
        amounts.map(a => inventory.prices.push({ ...a, price: a.amount }))
      }

      return { ...i, ...inventory, ...setting }
    })
  }

  const hide = () => {
    setAction({ ...action, open: false })
    setSelected([])
    onHide()
  }

  const filterProduct = item => {
    if (fieldRepeat) return true
    else return selected.findIndex(s => item.productId === s.productId) === -1
  }

  const filter = (item, search) => {
    if (search && search !== '') {
      const exp = new RegExp(search.toUpperCase(), 'g')
      const i = { name: item.productName, code: item.productCode }
      return Object.keys(i).some(p => `${JSON.stringify(i[p])}`.toUpperCase().match(exp))
    }
    return true
  }

  const getOptions = inventory => {
    return inventory.map(i => {
      return {
        ...i.inventory,
        url: i.imageUrl,
        companyName: i.companyName,
        value: i.inventory.productId,
        label: `${i.inventory.productCode} ${i.inventory.productName}`,
      }
    })
  }

  const handleCheckBoxChange = event => {
    const { name, checked } = event.target
    setFilters({ ...filters, [name]: checked })
  }

  const onChangeInput = (value, parameter) => {
    let comp = `${value || 0}`
    if (comp.match(/[0-9]+/g)) {
      if (value < 0) value = 0
      if (parameter === 'quantity') {
        let series = Array.apply(null, Array(Number(value))).map(() => '')
        if (toSelect.series) series = series.map((s, i) => toSelect.series[i])
        toSelect.series = series
      }
      setSelect({ ...toSelect, [parameter]: value })
    }
  }

  const getTotal = (param, tax, custom) => {
    let response = 0
    selected.map(s => {
      if (s[param]) {
        if (tax && !s.expense)
          response +=
            custom && s.customPrice
              ? s.customPrice / conversion
              : parseFloat(s[param]) + parseFloat(s.tax || 0)
        else response += Number(s[param]) || 0
      }
    })
    return response
  }

  const getMaxDiscount = (quantity, item) => {
    const discountLimit = module === 1000
    let max

    if (item.saleRecipe) {
      max = getSubTotal(item, true)
    } else {
      if (isNaN(quantity)) quantity = 0
      let discount = 0
      let price =
        type === serviceType.PURCHASE || type === serviceType.EXPENSES
          ? item.purchasePrice
          : (item.selectedPrice ? item.selectedPrice.value : item.productPrice) ||
            item.price
      if (item.prices && discountLimit) {
        //item.prices.filter((p) =>quantity >= p.minimum).map((p) => (discount = p.price));
        //if (item.discountLimit) discount -= (discount * 0.05);
        discount = price
      } else if (!discountLimit) discount = price

      if (item.discountLimited) discount = item.discountLimitedNumber
      max = parseFloat(discount) * parseFloat(quantity)
    }
    console.log(maxDiscount + ' ' + max)
    return Number.parseFloat((Number.parseFloat(maxDiscount) * max) / 100).toFixed(2)
  }

  const changeQuantity = (value, item, show) => {
    let quantity = parseInt(value)

    if (quantity < 0) quantity = 0
    /*if(item.productExistence <= 0){}
      else if (quantity > item.productExistence) quantity = item.productExistence;*/

    let nowQuantity = (item.transformationFactor || 1) * quantity
    if (item.subProductId)
      nowQuantity +=
        (item.subProductData.transformationFactor || 1) * (item.sQuantity || 0)

    item.realQuantity = nowQuantity / (item.transformationFactor || 1)
    item.quantity = quantity

    const maxDiscount = getMaxDiscount(
      nowQuantity / (item.transformationFactor || 1),
      item,
    )

    if (item.percentDiscount) {
      item.discount = (getSubTotal(item, true) / 100) * item.percent.value
    }
    if (parseFloat(item.discount) > maxDiscount) {
      item.discount = maxDiscount
    }
    item.maxDiscount = maxDiscount
    item.subTotal = getSubTotal(item)
    //if(!item.includeIva && serviceType.ORDERS === type) item.subTotal = item.subTotal/1.12

    setSelect({ ...item, show })
    setSelected([...selected])
  }

  const changeSQuantity = (value, item, show) => {
    let quantity = parseInt(value)
    const maxQuantity = item.saleRecipe ? 1000000 : item.subProductValue || 0

    if (quantity > maxQuantity) quantity = maxQuantity
    if (quantity < 0) quantity = 0

    let nowQuantity = (item.subProductData.transformationFactor || 1) * quantity

    if (item.quantity)
      nowQuantity += (item.transformationFactor || 1) * (item.quantity || 0)

    item.realQuantity = nowQuantity / (item.transformationFactor || 1)
    item.sQuantity = quantity

    const maxDiscount = getMaxDiscount(item.realQuantity, item)
    if (parseFloat(item.discount) > maxDiscount) item.discount = maxDiscount
    item.maxDiscount = maxDiscount
    item.subTotal = getSubTotal(item)
    //if(!item.includeIva && serviceType.ORDERS === type) item.subTotal = item.subTotal/1.12
    item.subPrice = getSubTotal({ ...item.subProductData, quantity })

    setSelect({ ...item, show })
    setSelected([...selected])
  }

  const getSubTotal = (item, ignore) => {
    let subTotal = 0
    let price =
      type === serviceType.PURCHASE || type === serviceType.EXPENSES
        ? item.purchasePrice
        : (item.selectedPrice ? item.selectedPrice.value : item.productPrice) ||
          item.price
    if (item.quantity >= 0) subTotal += (item.quantity || 0) * price
    if (item.sQuantity >= 0 && item.subProductData) {
      subTotal += (item.sQuantity || 0) * getSubPrice(item)
    }
    if (ignore) return subTotal
    else return subTotal - (item.discount || 0)
  }

  const getSubPrice = item => {
    const { saleRecipe, productPrice, subProductValue, subProductData, selectedPrice } =
      item
    let price = 0
    if (subProductData) {
      const useFactor = subProductData.useFactor
      if (saleRecipe == null)
        price = useFactor
          ? (selectedPrice ? selectedPrice.value : productPrice) / (subProductValue || 1)
          : subProductData.price
      else
        price = useFactor
          ? (subProductData.subProductValue / subProductValue) *
            (selectedPrice ? selectedPrice.value : productPrice)
          : subProductData.price
    }

    return price
  }

  const changeDiscount = (value, item, show) => {
    item.error = null
    if (!isNaN(value)) {
      let discount = value
      if (!discount || discount < 0) discount = 0
      else if (discount > Number.parseFloat(item.maxDiscount)) {
        item.error = 'El valor ingresado supera el descuento maximo'
        discount = item.maxDiscount
      }
      item.discount = discount
      item.subTotal = getSubTotal(item)

      setSelect({ ...toSelect, show })
      setSelected([...selected])
    }
  }

  const getTotalWithOutDiscount = () => {
    let total = 0
    selected.map((item, index) => {
      total += item.quantity * item.productPrice
    })
    return total
  }

  const getNewDiscount = (item, discount) => {
    let total = getTotalWithOutDiscount()
    let descuento = (item.quantity * item.productPrice * discount) / total
    // if (descuento > item.maxDiscount){
    //   descuento = parseFloat(item.maxDiscount)
    // }
    return descuento
  }

  const changeAllDiscount = (value, isPercent, type) => {
    if (value) {
      selected.map((item, index) => {
        item.error = null
        if (!item.value) {
          return
        }
        if (isPercent) {
          if (!type) {
            console.log('HI')
            percentDiscount(item, value, true)
          } else {
            console.log('HI2')
            percentDiscount(item, value, discountAll)
          }
        } else {
          console.log('HI3')
          item.percentDiscount = isPercent
          let descuento = getNewDiscount(item, value.value)
          changeDiscount(descuento, item)

          // changeDiscount(value.value , item);
        }
      })
      setSelected([...selected])
    }
  }

  const percentDiscount = (item, discount, isPercent) => {
    item.percentDiscount = isPercent
    item.error = null
    if (!isNaN(discount.value)) {
      let subtotal = 0
      if (isPercent) {
        item.percent = discount
        item.discount = (getSubTotal(item, true) / 100) * item.percent.value
        if (!discount.value || discount.value < 0) discount.value = 0
        else if (item.discount > Number.parseFloat(item.maxDiscount)) {
          item.discount = item.maxDiscount
          item.percent = discounts.find(
            x => x.value == (item.maxDiscount / getSubTotal(item, true)) * 100,
          )
          item.percentDiscount = !isPercent
          item.error = 'El porcentaje excede el descuento maximo'
        }
        subtotal = getSubTotal(item, false)
      } else {
        item.discount = discount.value
        subtotal = getSubTotal(item)
      }
      if (item.quantity > 0) item.subTotal = subtotal
      setSelect({ ...toSelect })
      setSelected([...selected])
    }
  }

  const checkFilter = item => {
    let { withoutcontract, inactive, withoutExistence, consigned, own } = filters

    if (module === 2000) {
      withoutcontract = true
      item.prices = []
    }

    return (
      (item.productActive || (inactive && !item.productActive)) &&
      (item.contract || (withoutcontract && !item.contract)) &&
      //((item.productExistence > 0) || (withoutExistence && item.productExistence <= 0)) &&
      ((consigned && item.origin === 1) || (own && item.origin !== 1))
    )
  }

  const loadCSV = list => {
    let items = getOptions(inventory)
    let response = []
    list.map(l => {
      let index = items.findIndex(d => d.value === l.productId)
      if (index !== -1) {
        response.push({
          ...items[index],
          quantity: l.quantity,
          price: l.price,
          subTotal: l.subtotal,
          customPrice: l.customPrice,
          expirationDate: l.expirationDate ? new Date(l.expirationDate) : null,
          active: !!l.series,
          series: l.series ? l.series.map(s => s.serie) : null,
          tax: l.tax,
        })
      }
    })
    setSelected([...response])
  }

  const validateSeries = () => {
    let array = []
    toSelect.series.map(p => {
      if (p) {
        let index = array.findIndex(f => f === p)
        if (index < 0) array.push(p)
      }
    })
    return array.length === toSelect.series.length
  }

  const disabledOptions = () => {
    if (type === serviceType.ORDERS) {
      if (!toSelect.includeIva && toSelect.phraseReference === null) return true
      return !(
        (toSelect.quantity && toSelect.quantity >= 0) ||
        (toSelect.sQuantity && toSelect.sQuantity >= 0)
      )
    } else if (type === serviceType.PURCHASE) {
      return toSelect.onlySeries
        ? toSelect.active && !validateSeries()
        : !toSelect.subTotal ||
            toSelect.subTotal <= 0 ||
            (toSelect.active && !validateSeries()) ||
            (importation && (!toSelect.tax || toSelect.tax < 0))
    } else if (type === serviceType.EXPENSES) {
      return !toSelect.subTotal || toSelect.subTotal <= 0
    }
    return true
  }

  const getList = list => {
    return serviceType.ORDERS === type
      ? getOptions(list ? list : inventory)
          .filter(filterProduct)
          .filter(checkFilter)
      : getOptions(list ? list : inventory).filter(filterProduct)
  }

  const updateTaxFree = (item, type) => {
    selected.map((product, index) => {
      if (item.newIncludeIva || type) {
        product.includeIva = item.newIncludeIva
        product.newIncludeIva = false
      } else {
        product.phraseReference = item.phraseReference
        product.includeIva = false
        product.newIncludeIva = true
      }
    })
    setTaxFree(false)
    setShowIVA(false)
    setSelected([...selected])
  }

  const updatePriceIVA = (item, show) => {
    let newValue

    if (item.includeIva !== item.newIncludeIva) {
      let unitPrice = item.productPrice
      if (item.selectedPrice) unitPrice = item.selectedPrice.value

      let alias = ''
      let label = ''
      /*
      if (item.newIncludeIva) {
        // add value with iva
        unitPrice = Number.parseFloat(unitPrice * 1.12).toFixed(2);
        alias = "Precio con IVA";
      } else {
        // add value without iva
        unitPrice = Number.parseFloat(unitPrice / 1.12).toFixed(2);
        alias = "Precio sin IVA";
      }
       */

      label = toMoney(unitPrice)
      item.productPrice = unitPrice
      item.price = unitPrice
      item.includeIva = item.newIncludeIva
      item.selectedAlias = alias

      if (item.selectedPrice) {
        item.selectedPrice = {
          alias,
          label,
          value: unitPrice,
        }
      }
      newValue = item
      changeQuantity(item.quantity, item, show)
    } else {
      newValue = { ...selected[item.edit], phraseReference: item.phraseReference }
    }
    if (!show) {
      if (item.edit >= 0) selected[item.edit] = newValue
      else selected.push(newValue)
      setSelected([...selected])
      setShowIVA(false)
      setSelect({})
    }
  }

  const getCommentaryComponent = (item, index) => (
    <Commentary
      value={item.commentary}
      onChange={value => {
        selected[index].commentary = value
        setSelected([...selected])
      }}
      textCommentary={item.label}
      edit
      max={1000}
    />
  )

  const renderTable = () => {
    let headers = [
      { label: '', show: true },
      { label: 'Producto', show: true },
      { label: 'Cantidad', show: true },
    ]
    if (type === serviceType.ORDERS) {
      headers = [
        { label: '', show: true },
        { label: 'Producto', show: true },
        { label: 'Existencia', show: true },
        { label: 'Cantidad', show: true },
        { label: 'Precio', show: true },
        { label: 'Sub-Producto', show: true },
        { label: 'Cantidad', show: true },
        { label: 'Descuento', show: true },
        { label: 'Sub-total', show: true },
        // { label: 'Comentario', show: false },
      ]
      // if(allowDisableIva){
      //   header = [...header,  'IVA']
      // }
      // header = [...header, ]
    } else if (type === serviceType.PURCHASE && !order) {
      if (importation) {
        headers.push(
          ...[
            { label: 'Precio', show: true },
            {
              label: `Sub-total ${activateLocalCurrency ? exchangeRate.symbol : '$'}`,
              show: true,
            },
            { label: 'Fecha de vencimiento', show: true },
            {
              label: `Tasa de impuestos (${
                activateLocalCurrency ? exchangeRate.symbol : '$'
              })`,
              show: true,
            },
            {
              label: `Total (${exchangeRate !== undefined ? exchangeRate.symbol : ''})`,
              show: true,
            },
          ],
        )
      } else {
        headers.push(
          ...[
            { label: 'Precio', show: true },
            { label: `Sub-total (${currentCurrency.symbol})`, show: true },
            { label: 'Fecha de vencimiento', show: true },
          ],
        )
      }
    } else if (type === serviceType.EXPENSES) {
      headers.push(
        ...[
          { label: 'Precio', show: true },
          { label: `Sub-total (${currentCurrency.symbol})`, show: true },
        ],
      )
    }
    headers.push({ label: '', show: true })

    return (
      <>
        <TableV2
          loading={loading}
          customFilter={customFilter()}
          onScan={barcode => {
            setBarcodeValue(true)
            dispatch(
              getInventoryWithPrices(
                warehouse.value,
                '',
                '',
                false,
                type,
                filters.withoutExistence,
                null,
                null,
                null,
                barcode,
              ),
            )
          }}
          customClass={'scrollX'}
          items={[...selected, { add: true }]}
          headers={headers}
          renderRow={(item, index) => {
            if (discount !== null && item.productId !== undefined) {
              let descuento = getNewDiscount(item, discount)

              if (!isNaN(descuento) && descuento < item.maxDiscount) {
                item.error = null
                sumDiscount = Number(sumDiscount) + parseFloat(descuento.toFixed(2))
                if (index === selected.length - 1) {
                  if (Number(sumDiscount) !== Number(discount)) {
                    descuento = descuento - 0.01
                  }
                }
                item.discount = descuento.toFixed(2)
                let subtotal = getSubTotal(item)
                if (item.quantity > 0) item.subTotal = subtotal
              }
            }

            return (
              <Tr key={`${index}`} className={`data ${item.add ? 'disable-row' : ''}`}>
                <Td
                  style={{ marginBottom: serviceType.ORDERS === type ? '10px' : '0px' }}
                  className={'mini'}>
                  {!item.add && (
                    <div>
                      <IconImg
                        imgStyle={{ width: 50, height: 50 }}
                        icon={item.url || holder}
                      />
                    </div>
                  )}
                </Td>
                <Td className={'name d-flex center center-margin'}>
                  {!item.add ? (
                    <div
                      style={{
                        marginTop:
                          allowDisableIva && item.productId && type === serviceType.ORDERS
                            ? 20
                            : 0,
                      }}>
                      <CustomCreate
                        mt={1}
                        style={{ width: 380, flex: 1 }}
                        withoutLabel
                        options={
                          serviceType.ORDERS === type
                            ? getOptions(inventory)
                                .filter(filterProduct)
                                .filter(checkFilter)
                            : getOptions(inventory).filter(filterProduct)
                        }
                        value={item}
                        onChange={value => {
                          // selected[index] = {...value, phraseReference: phrases.find(d => d.value === value.phraseReference)};
                          selected[index] = {
                            ...value,
                            phraseReference: null,
                            includeIva: true,
                          }
                          selected[index].list &&
                            selected[index].list.map(s => {
                              if (s.price === value.productPrice)
                                selected[index].selectedAlias = s.alias
                            })
                          changeQuantity(
                            type === serviceType.EXPENSES || type === serviceType.PURCHASE
                              ? 1
                              : 0,
                            selected[index],
                            false,
                          )
                          if (type === serviceType.EXPENSES)
                            selected[index].subTotal = value.expensePrice
                              ? value.expensePrice
                              : 0
                          else if (type === serviceType.PURCHASE)
                            selected[index].subTotal = value.purchasePrice
                              ? value.purchasePrice
                              : 0
                        }}
                        disabled={item.add}
                        placeholder={'Seleccione un producto'}
                        textLabel={'Buscar producto: '}
                        isLoading={loadingInventory}
                        async
                        dontClear
                        loadOptions={async search => {
                          if (
                            !(search === null || search === undefined || search === '')
                          ) {
                            console.log('AQUI')
                            let data = await WarehouseService.getInventoryWithPrices({
                              warehouse: warehouse.value,
                              reserve: false,
                              typeId: type,
                              withZero: filters.withoutExistence,
                              search,
                            })
                            data = formatInventory(data)

                            setInventory(data)
                            return getList(data)
                          } else return getList()
                        }}
                      />

                      {type === serviceType.ORDERS &&
                        item.productId &&
                        getCommentaryComponent(item, index)}

                      {allowDisableIva &&
                      item.productId &&
                      type === serviceType.ORDERS &&
                      !item.includeIva ? (
                        <div
                          className="ft-sub left mt-2 ml-2"
                          style={{
                            cursor: 'pointer',
                            fontWeight: 500,
                            textDecoration: 'underline',
                          }}
                          onClick={() => {
                            setSelect({
                              ...item,
                              edit: index,
                              newIncludeIva: item.includeIva,
                            })
                            setShowIVA(true)
                          }}>
                          {`Exento de IVA: ${
                            item.phraseReference &&
                            item.phraseReference.label.substring(0, 25)
                          }...`}
                        </div>
                      ) : (
                        allowDisableIva &&
                        item.productId &&
                        type === serviceType.ORDERS && (
                          <div
                            className="ft-sub left mt-2 ml-2"
                            style={{
                              cursor: 'pointer',
                              fontWeight: 500,
                              textDecoration: 'underline',
                            }}
                            onClick={() => {
                              setSelect({
                                ...item,
                                edit: index,
                                newIncludeIva: item.includeIva,
                              })
                              setShowIVA(true)
                            }}>
                            Quitar IVA
                          </div>
                        )
                      )}
                    </div>
                  ) : (
                    <div
                      className={'d-flex'}
                      style={{ justifyContent: 'space-between' }}
                      onClick={() => {
                        if (type === serviceType.ORDERS && !warehouse.value)
                          setError('Seleccione primero una bodega')
                        else {
                          selected.push({})
                          setSelected([...selected])
                          setError(null)
                          console.log('AQUI ESRA')
                          dispatch(
                            getInventoryWithPrices(
                              warehouse.value,
                              client ? client.latitude : 14.55,
                              client ? client.longitude : -90.55,
                              false,
                              type,
                              filters.withoutExistence,
                              null,
                              true,
                              [],
                            ),
                          )
                        }
                      }}>
                      <Icon
                        icon={faPlusCircle}
                        style={{
                          marginBottom: serviceType.ORDERS === type ? '10px' : '0px',
                        }}
                        size={'2x'}
                        tooltip={'Agregar'}
                        placement={'right'}
                        color={'#47c55c'}
                      />
                      <div className={'disable-row-text'}>Agregar producto</div>
                    </div>
                  )}
                </Td>
                {!item.add && type === serviceType.ORDERS && (
                  <Td className={'mini center'}>
                    {`${formatNumberWithCommas(
                      item.teoricExistence
                        ? item.productTeoricalExistence
                        : item.productExistence || 0,
                    )} U.`}
                  </Td>
                )}
                {item.add ? (
                  <>
                    <Td />
                    <Td />
                    <Td />
                    {serviceType.PURCHASE === type && !order && (
                      <>
                        <Td />
                        <Td />
                      </>
                    )}
                    {serviceType.PURCHASE === type && order && (
                      <>
                        <Td />
                      </>
                    )}
                    {importation && (
                      <>
                        <Td />
                        <Td />
                        <Td />
                      </>
                    )}
                    {serviceType.ORDERS === type && (
                      <>
                        <Td />
                        <Td />
                        <Td />
                        <Td />
                        <Td />
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <Td
                      className={`${
                        type === serviceType.EXPENSES ? 'name' : 'short'
                      } center`}>
                      <FormText
                        style={{ marginBottom: '0px', width: 70 }}
                        disabled={!item.value}
                        mt={1}
                        type={'number'}
                        value={item.quantity}
                        onChange={({ target }) => {
                          if (type === serviceType.ORDERS)
                            changeQuantity(target.value, selected[index])
                          else {
                            selected[index].quantity = target.value
                            setSelected([...selected])
                          }
                        }}
                      />
                    </Td>
                    {(type === serviceType.PURCHASE || type === serviceType.EXPENSES) &&
                      !order && (
                        <>
                          <Td className={'short center'}>{`${
                            importation
                              ? activateLocalCurrency
                                ? exchangeRate.symbol
                                : '$'
                              : currentCurrency.symbol
                          } ${formatNumberWithCommas(
                            (item.subTotal || 0) / (item.quantity || 1),
                          )}`}</Td>
                          <Td
                            className={`${
                              type === serviceType.EXPENSES ? 'name' : 'medium'
                            } center`}>
                            <FormText
                              disabled={!item.value}
                              mt={1}
                              type={'number'}
                              value={item.subTotal}
                              onChange={({ target }) => {
                                selected[index].subTotal = target.value
                                setSelected([...selected])
                              }}
                            />
                          </Td>
                        </>
                      )}
                    {type !== serviceType.PURCHASE && type !== serviceType.EXPENSES && (
                      <>
                        <Td
                          className={`${
                            (savePrice && item.activeUpdatable) ||
                            (multiplePrices && item.list && item.list.length > 1)
                              ? 'medium'
                              : 'mini'
                          } center`}>
                          {savePrice && item.activeUpdatable ? (
                            <CustomCreate
                              placeholder={'Buscar o seleccionar'}
                              value={
                                item.selectedPrice || {
                                  value: item.productPrice,
                                  label: item.productPrice,
                                }
                              }
                              textLabel={`Agregar precio ${currentCurrency.symbol}`}
                              mt={0}
                              style={{ width: 150, flex: 1 }}
                              withoutLabel
                              disabled={item.add}
                              options={
                                item.list
                                  ? item.list.map((l, i) => ({
                                      value: Number(l.price),
                                      alias: l.alias,
                                      label: `${l.alias} - ${toMoney(l.price)}`,
                                    }))
                                  : []
                              }
                              alias={selected[index].selectedAlias}
                              onCreateOption={value => {
                                if (!isNaN(value)) {
                                  if (value < 0) value = 0
                                  selected[index].productPrice = value
                                  selected[index].price = value
                                  selected[index].selectedPrice = {
                                    value: Number(value),
                                    label: toMoney(value),
                                    alias: 'Nuevo precio',
                                  }
                                  selected[index].selectedAlias = 'Nuevo precio'
                                  selected[index].save = false
                                  if (!selected[index].includeIva) {
                                    updatePriceIVA({
                                      ...selected[index],
                                      edit: index,
                                      includeIva: !selected[index].includeIva,
                                      newIncludeIva: selected[index].includeIva,
                                    })
                                    setTimeout(() => {
                                      changeQuantity(
                                        item.quantity,
                                        selected[index],
                                        false,
                                      )
                                    }, 300)
                                  } else
                                    changeQuantity(item.quantity, selected[index], false)
                                }
                              }}
                              onChange={value => {
                                if (value) {
                                  let comp = `${value.value || 0}`
                                  if (comp.match(/[0-9]+/g)) {
                                    if (value.value < 0)
                                      value = {
                                        value: Number(value.value),
                                        label: toMoney(value.value),
                                      }
                                    selected[index].price = value.value
                                    selected[index].productPrice = value.value
                                    selected[index].selectedPrice = {
                                      ...value,
                                      label: toMoney(value.value),
                                    }
                                    selected[index].selectedAlias = value.alias
                                    selected[index].save = false

                                    if (!selected[index].includeIva) {
                                      updatePriceIVA({
                                        ...selected[index],
                                        edit: index,
                                        includeIva: !selected[index].includeIva,
                                        newIncludeIva: selected[index].includeIva,
                                      })
                                      setTimeout(() => {
                                        changeQuantity(
                                          item.quantity,
                                          selected[index],
                                          false,
                                        )
                                      }, 300)
                                    } else
                                      changeQuantity(
                                        item.quantity,
                                        selected[index],
                                        false,
                                      )
                                  }
                                }
                              }}
                            />
                          ) : multiplePrices && item.list && item.list.length > 0 ? (
                            <Select
                              value={
                                item.selectedPrice || {
                                  value: item.productPrice,
                                  label: item.productPrice,
                                }
                              }
                              options={item.list.map((l, i) => ({
                                value: Number(l.price),
                                alias: l.alias,
                                label: `${l.alias} - ${toMoney(l.price)}`,
                              }))}
                              onChange={value => {
                                selected[index].selectedPrice = {
                                  ...value,
                                  label: toMoney(value.value),
                                }
                                selected[index].selectedAlias = value.alias
                                changeQuantity(item.quantity, selected[index], false)
                              }}
                              mt={0}
                              style={{ width: 150, flex: 1 }}
                              withoutLabel
                              disabled={item.add}
                              alias={selected[index].selectedAlias}
                            />
                          ) : (
                            toMoney(item.productPrice)
                          )}
                        </Td>
                        <Td>
                          {item.subProductData
                            ? item.subProductData.name
                            : item.add
                            ? ''
                            : 'Sin Subproducto'}
                        </Td>
                        <Td className={'short center'}>
                          <FormText
                            style={{
                              width: 70,
                              marginBottom: serviceType.ORDERS === type ? '10px' : '0px',
                            }}
                            mt={1}
                            type={'number'}
                            value={item.sQuantity}
                            disabled={!item.subProductId}
                            onChange={({ target }) =>
                              changeSQuantity(target.value, selected[index])
                            }
                          />
                        </Td>
                      </>
                    )}
                    {type === serviceType.ORDERS && (
                      <>
                        <Td className={`medium center`}>
                          <div className={'d-flex justify-between'}>
                            <Col>
                              {item.percentDiscount ? (
                                <>
                                  <Select
                                    mt={0}
                                    style={{ width: 90, flex: 1 }}
                                    value={item.percent}
                                    withoutLabel
                                    onChange={value => percentDiscount(item, value, true)}
                                    options={discounts}
                                    error={item.error}
                                    disabled={isGeneral}
                                  />
                                  <label>
                                    {' '}
                                    Q.{formatNumberWithCommas(item.discount || 0)}
                                  </label>
                                </>
                              ) : (
                                <FormText
                                  style={{ width: 90 }}
                                  mt={1}
                                  disabled={!item.value || isGeneral}
                                  type={'number'}
                                  value={
                                    item.percentDiscount ? item.percent : item.discount
                                  }
                                  onChange={({ target }) => {
                                    changeDiscount(target.value, selected[index])
                                  }}
                                  error={item.error}
                                />
                              )}
                            </Col>
                            <Col>
                              <label>
                                <b> %</b>
                              </label>
                              <input
                                disabled={isGeneral}
                                type="checkbox"
                                id="idchk"
                                name="chk"
                                checked={item.percentDiscount}
                                onChange={e => {
                                  percentDiscount(
                                    item,
                                    { label: '0%', value: 0 },
                                    e.currentTarget.checked,
                                  )
                                }}
                              />
                            </Col>
                          </div>
                        </Td>
                        <Money component={Td} className={'short center'}>
                          {item.subTotal}
                        </Money>
                        {/*
                        <Td className={'short center'}>
                          <FormText
                            mt={1}
                            disabled={!item.value}
                            value={item.commentary}
                            onChange={({ target }) => {
                              selected[index].commentary = target.value
                              setSelected([...selected])
                            }}
                          />
                        </Td> */}
                      </>
                    )}
                    {type === serviceType.PURCHASE && !order && (
                      <Td className={'name center inherit'}>
                        <CustomDate
                          mt={1}
                          disabled={!item.value}
                          value={item.expirationDate}
                          disabledDays={[]}
                          onDayChange={d => {
                            selected[index].expirationDate = d
                            setSelected([...selected])
                          }}
                        />
                      </Td>
                    )}
                    {type === serviceType.PURCHASE && !order && importation && (
                      <>
                        <Td className={'short center'}>
                          <FormText
                            mt={1}
                            disabled={!item.value}
                            type={'number'}
                            value={item.tax}
                            onChange={({ target }) => {
                              selected[index].tax = target.value
                              setSelected([...selected])
                            }}
                          />
                        </Td>
                        <Td className={'name center d-flex'}>
                          <FormText
                            mt={1}
                            disabled={!item.value}
                            type={'number'}
                            value={
                              item.customPrice ||
                              formatNumberWithCommas(
                                (Number(item.subTotal) + Number(item.tax || 0)) *
                                  conversion,
                              )
                            }
                            onChange={({ target }) => {
                              selected[index].customPrice = target.value
                              setSelected([...selected])
                            }}
                          />
                        </Td>
                      </>
                    )}
                    <Td className={'mini'}>
                      {!item.add && (
                        <div className={'d-flex justify-between'}>
                          {!importation && type === serviceType.PURCHASE && !order && (
                            <Button
                              color={'accent'}
                              onClick={() => {
                                let series = Array.apply(
                                  null,
                                  Array(Number(item.quantity || 0)),
                                ).map(() => '')
                                if (item.series)
                                  series = series.map((s, i) => item.series[i])
                                setSelect({
                                  ...item,
                                  show: true,
                                  onlySeries: true,
                                  series,
                                  edit: index,
                                })
                                console.log(series)
                              }}>
                              <Icon tooltip={'Números de Serie'} icon={faBarcode} />
                            </Button>
                          )}
                          <Button
                            style={{
                              marginBottom: serviceType.ORDERS === type ? '5px' : '0px',
                            }}
                            color={'accent'}
                            onClick={() => {
                              setSelected(selected.filter((d, i) => i !== index))
                            }}>
                            <Icon tooltip={'Descartar'} icon={faTrash} />
                          </Button>
                        </div>
                      )}
                    </Td>
                  </>
                )}
              </Tr>
            )
          }}
        />
      </>
    )
  }

  const customFilter = () => {
    const { consigned, own, inactive, withoutExistence, withoutContract } = filters

    return (
      <div>
        <Row>
          {serviceType.ORDERS === type && (
            <Col xl={12}>
              <Row>
                <Col xl={!2}>
                  <Row>
                    <Col style={{ alignSelf: 'flex-end' }}>
                      <div className={'justify-center column'}>
                        <label className={'checkbox-label'}>
                          <input
                            type={'checkbox'}
                            name={'inactive'}
                            checked={inactive}
                            onChange={handleCheckBoxChange}
                          />{' '}
                          Inactivas
                        </label>
                      </div>
                    </Col>
                    <Col style={{ alignSelf: 'flex-end' }}>
                      <div className={'justify-center column'}>
                        <label className={'checkbox-label'}>
                          <input
                            type={'checkbox'}
                            name={'withoutContract'}
                            checked={withoutContract}
                            onChange={handleCheckBoxChange}
                          />{' '}
                          Sin contrato
                        </label>
                      </div>
                    </Col>
                    <Col style={{ alignSelf: 'flex-end' }}>
                      <div className={'justify-center column'}>
                        <label className={'checkbox-label'}>
                          <input
                            type={'checkbox'}
                            name={'withoutExistence'}
                            checked={withoutExistence}
                            onChange={({ target }) => {
                              const { checked } = target
                              setFilters({ ...filters, withoutExistence: checked })
                              dispatch(
                                getInventoryWithPrices(
                                  warehouse.value,
                                  client.latitude,
                                  client.longitude,
                                  false,
                                  type,
                                  checked,
                                  searchA ? searchA : '090018',
                                ),
                              )
                            }}
                          />
                          &nbsp; Sin existencia
                        </label>
                      </div>
                    </Col>
                    <Col style={{ alignSelf: 'flex-end' }}>
                      <div className={'justify-center column'}>
                        <label className={'checkbox-label'}>
                          <input
                            type={'checkbox'}
                            name={'consigned'}
                            checked={consigned}
                            onChange={handleCheckBoxChange}
                          />{' '}
                          Producto consignado
                        </label>
                      </div>
                    </Col>
                    <Col style={{ alignSelf: 'flex-end' }}>
                      <div className={'justify-center column'}>
                        <label className={'checkbox-label'}>
                          <input
                            type={'checkbox'}
                            name={'own'}
                            checked={own}
                            onChange={handleCheckBoxChange}
                          />{' '}
                          Producto de la empresa
                        </label>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xl={12}>
                  <div>
                    <hr />
                  </div>
                </Col>

                {selected.length > 0 && (
                  <Col xl={12}>
                    <Row className={'container-buttons'}>
                      <div className={'column'}>
                        <span>Exentos de iva</span>

                        <div className={'d-flex'}>
                          <OverlayTrigger
                            placement={'top'}
                            overlay={
                              <Tooltip id={`tooltip`}>
                                Marcar todos los items como exentos de iva
                              </Tooltip>
                            }>
                            <span className="d-inline-block">
                              <Button
                                style={{ flex: 1 }}
                                color={'primary'}
                                onClick={() => {
                                  setTaxFree(true)
                                  setShowIVA(true)
                                }}>
                                Exento de IVA
                              </Button>
                            </span>
                          </OverlayTrigger>

                          <OverlayTrigger
                            placement={'top'}
                            overlay={
                              <Tooltip id={`tooltip`}>
                                Quitar exentos de iva a todos los items
                              </Tooltip>
                            }>
                            <span className="d-inline-block">
                              <Button
                                style={{ flex: 1 }}
                                color={'secondary'}
                                onClick={() => {
                                  updateTaxFree({ newIncludeIva: true })
                                }}>
                                Quitar Exento de IVA
                              </Button>
                            </span>
                          </OverlayTrigger>
                        </div>
                      </div>

                      <div className={'column ml-3'}>
                        <span>Descuentos</span>

                        <div className={'d-flex'}>
                          {discountAll ? (
                            <Select
                              mt={0}
                              style={{ width: 120, flex: 1 }}
                              withoutLabel
                              onChange={value => {
                                setDiscount(value)
                                changeAllDiscount(value, discountAll, true)
                              }}
                              options={discounts}
                              error={error}
                            />
                          ) : (
                            <FormText
                              style={{ width: 100 }}
                              mt={1}
                              type={'number'}
                              onChange={({ target }) => {
                                if (target.value === '') setIsGeneral(false)
                                else if (!isGeneral) setIsGeneral(true)
                                setDiscount(target.value)
                                changeAllDiscount(
                                  { value: target.value },
                                  discountAll,
                                  true,
                                )
                              }}
                            />
                          )}

                          <div className={'column'}>
                            <Checkbox
                              type="checkbox"
                              id="idchk"
                              name="chk"
                              label={'%'}
                              topLabel
                              checked={discountAll}
                              onChange={({ target }) => {
                                if (!target.checked) setIsGeneral(false)
                                else setIsGeneral(true)
                                setDiscountAll(target.checked)
                                changeAllDiscount(
                                  { label: '0%', value: 0 },
                                  target.checked,
                                  false,
                                )
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Row>
                  </Col>
                )}
              </Row>
            </Col>
          )}
          {(serviceType.PURCHASE === type || serviceType.EXPENSES === type) && (
            <Col>
              <CSVLoader
                category={CATEGORY_UPLOAD.PURCHASE}
                info
                title={'Carga Masiva de Productos'}
                onUpload={(file, onSuccess) => {
                  dispatch(
                    loadProducts(
                      file,
                      onSuccess,
                      type === serviceType.EXPENSES ? 2 : importation ? 1 : 0,
                    ),
                  )
                }}
                onSuccess={response => loadCSV(response ? response.list : [])}
              />
            </Col>
          )}
        </Row>
        <hr />
      </div>
    )
  }

  const itemsToSelect = (toAssign, items, title, noItemsLegend, search, setSearch) => {
    //const is = (items && items.filter((i) => filter(i, search)).length > 0) ? items.filter((i) => filter(i, search)) : [];
    const is =
      items && items.length > 0
        ? toAssign
          ? items
          : items.filter(i => filter(i, search))
        : []

    return (
      <div>
        {toAssign && serviceType.PURCHASE !== type && type !== serviceType.EXPENSES && (
          <Select
            label={'Bodegas'}
            value={warehouse}
            disabled={!client}
            onChange={value => setWarehouse(value)}
            options={warehouses}
            error={error}
            loading={loadingW}
            subText={
              serviceType.ORDERS === type &&
              warehouse &&
              warehouse?.posId &&
              `Punto de venta: ${warehouse.posName}`
            }
          />
        )}
        <div style={toAssign ? {} : { marginTop: 45 }}>
          <CustomFilter
            search={search}
            onChange={({ target }) => {
              const value = target.value
              setSearch(value)
              if (toAssign && value !== null && value !== undefined && value !== '') {
                clearTimeout(interval)
                setLoadingSearch(true)
                interval = setTimeout(() => {
                  setLoadingSearch(false)
                  dispatch(
                    getInventoryWithPrices(
                      warehouse.value,
                      '',
                      '',
                      false,
                      type,
                      filters.withoutExistence,
                      target.value,
                    ),
                  )
                }, 1000)
              }
            }}
            customFilter={customFilter()}
          />
        </div>

        <Accordion style={{ height: 400 }}>
          <div>
            {toAssign && (loadingSearch || loadingInventory) && (
              <Row>
                <Col>
                  <div className={'pb-custom'}>
                    <ProgressBar
                      label="Cargando"
                      animated
                      now={100}
                      style={{ marginBottom: 10 }}
                    />
                  </div>
                </Col>
              </Row>
            )}

            {is.length > 0 ? (
              <ul className="main-list">
                {is.map((item, index) => (
                  <li key={index}>
                    <Media>
                      {({ breakpoints, currentBreakpoint }) => {
                        const mobile = breakpoints[currentBreakpoint] < breakpoints.tablet

                        return breakpoints[currentBreakpoint] >= breakpoints.mini ? (
                          <div>
                            <RenderItems
                              item={item}
                              eventKey={`${index}`}
                              blockDiscount={blockDiscount}
                              toAssign={toAssign}
                              activateLocalCurrency={activateLocalCurrency}
                              exchangeRate={exchangeRate}
                              mobile={mobile}
                              onEdit={() => {
                                setSelect({
                                  ...item,
                                  show: true,
                                  edit: index,
                                  onlySeries: false,
                                })
                              }}
                              type={type}
                              importation={importation}
                              conversion={conversion}
                              currentCurrency={currentCurrency}
                              onAction={() => {
                                if (toAssign) {
                                  item = {
                                    ...item,
                                    phraseReference: null,
                                    includeIva: true,
                                    newIncludeIva: true,
                                  }
                                  changeQuantity(0, item, true)
                                } else setSelected(selected.filter((s, i) => index !== i))
                              }}
                            />
                          </div>
                        ) : (
                          <div />
                        )
                      }}
                    </Media>
                  </li>
                ))}
              </ul>
            ) : (
              <h6>
                {search && search !== '' && !loadingSearch && !loadingInventory
                  ? 'No se encontraron productos con los filtros aplicados'
                  : noItemsLegend}
              </h6>
            )}
          </div>
        </Accordion>
      </div>
    )
  }

  const renderSeries = () => {
    return (
      <>
        <Col xl={12} md={12}>
          <div style={{ display: 'flex', marginTop: 8 }}>
            <Switch
              checked={toSelect.active}
              id={'active'}
              onChange={({ target }) => {
                if (!toSelect.quantity || toSelect.quantity <= 0) {
                  setAlert({
                    ...handlerError('Ingrese una cantidad para habilitar el botón'),
                    onConfirm: () => setAlert({ show: false }),
                  })
                  setSelect({ ...toSelect })
                } else setSelect({ ...toSelect, active: target.checked })
              }}
              label={'Agregar números de serie'}
              info={
                'La cantidad de números de serie depende de la cantidad del producto ingresado'
              }
            />
          </div>
        </Col>
        {toSelect.active &&
          toSelect.series.map((p, index) => (
            <Col xl={12} md={12} key={index}>
              <FormText
                label={'Número de serie unidad No.' + (index + 1)}
                value={p}
                required
                onChange={({ target }) => {
                  toSelect.series[index] = target.value
                  setSelect({ ...toSelect })
                }}
              />
            </Col>
          ))}
      </>
    )
  }

  const render = () => {
    return (
      <div>
        <Title
          action={type === serviceType.EXPENSES || type === serviceType.PURCHASE}
          actionTitle={'Crear producto'}
          dontHide
          onClick={() => setCPShow(true)}
        />
        <div>
          <Media>
            {({ breakpoints, currentBreakpoint }) => {
              const tablet = breakpoints[currentBreakpoint] > breakpoints.tablet

              return breakpoints[currentBreakpoint] >= breakpoints.mini ? (
                <Row>
                  {!tablet && !order && balancesPermission && (
                    <>
                      <Col style={{ alignSelf: 'flex-end' }}>
                        <Card bodyStyle={{ paddingTop: 18, paddingBottom: 18 }}>
                          <div className={'justify-center column'}>
                            <span>Total</span>
                            {importation ? (
                              activateLocalCurrency ? (
                                <>
                                  <h4>
                                    <strong>{`
                                    ${exchangeRate && exchangeRate.symbol}${toMoney(
                                      Number(getTotal('subTotal', true, true)) *
                                        conversion,
                                      true,
                                    )}`}</strong>
                                  </h4>
                                </>
                              ) : (
                                <>
                                  <h4>
                                    <strong>{`$.${formatNumberWithCommas(
                                      getTotal('subTotal', true, false),
                                    )} / 
                                  ${exchangeRate && exchangeRate.symbol}${toMoney(
                                      Number(getTotal('subTotal', true, true)) *
                                        conversion,
                                      true,
                                    )}`}</strong>
                                  </h4>
                                </>
                              )
                            ) : (
                              <Money component="h4">
                                <strong>{Number(getTotal('subTotal'))}</strong>
                              </Money>
                            )}
                          </div>
                        </Card>
                      </Col>
                      {type !== serviceType.PURCHASE && type !== serviceType.EXPENSES && (
                        <Col style={{ alignSelf: 'flex-end' }}>
                          <Card>
                            <div className={'justify-center column'}>
                              <span>Descuento</span>
                              <Money component="h4">
                                <strong>{getTotal('discount')}</strong>
                              </Money>
                            </div>
                          </Card>
                        </Col>
                      )}

                      {importation && (
                        <Col>
                          <Card bodyStyle={{ paddingTop: 18, paddingBottom: 18 }}>
                            <div className={'justify-center column'}>
                              <Switch
                                topLabel
                                name={'withExistence'}
                                checked={activateLocalCurrency}
                                onChange={e => {
                                  setActivateLocalCurrency(!activateLocalCurrency)

                                  if (!e.target.checked) {
                                    setExchangeRate(
                                      currenciesOwn.find(c => c.code === 'GTQ'),
                                    )
                                    let money = getExchangeRate('GTQ')
                                    setConversion(Number(money.exchange))
                                    selected.conversion = Number(money.exchange)
                                  } else {
                                    setExchangeRate(currentCurrency)
                                    setConversion(1)
                                    selected.conversion = Number(1)

                                    if (currentCurrency.code === 'USD') {
                                      setLocalCurrency(false)
                                    } else {
                                      setLocalCurrency(true)
                                    }
                                  }
                                  setSelected([...selected])
                                }}
                                label={`Moneda Local (${currentCurrency.symbol})`}
                                info={'Manejar todo con moneda local'}
                              />

                              {!activateLocalCurrency && (
                                <>
                                  <span>Tasa de Conversión</span>

                                  <FormText
                                    type={'number'}
                                    prependMoneySymbol
                                    value={conversion}
                                    onChange={({ target }) =>
                                      setConversion(Number(target.value))
                                    }
                                  />
                                </>
                              )}
                            </div>
                          </Card>
                        </Col>
                      )}
                    </>
                  )}
                  <Col xl={12} lg={12} md={12} sm={12}>
                    <Card>
                      <Row>
                        {!isLimit &&
                          tablet &&
                          type !== serviceType.PURCHASE &&
                          type !== serviceType.EXPENSES && (
                            <Col>
                              <Select
                                label={'Bodegas'}
                                value={warehouse}
                                disabled={!client}
                                onChange={value => setWarehouse(value)}
                                options={warehouses}
                                error={error}
                                subText={
                                  serviceType.ORDERS === type &&
                                  warehouse &&
                                  warehouse?.posId &&
                                  `Punto de venta: ${warehouse.posName}`
                                }
                              />
                            </Col>
                          )}
                        {tablet && !order && balancesPermission && (
                          <Col style={{ alignSelf: 'flex-end' }}>
                            <div className={'justify-center column'}>
                              <span>Total</span>
                              {importation ? (
                                activateLocalCurrency ? (
                                  <>
                                    <h4>
                                      <strong>{`
                            ${exchangeRate && exchangeRate.symbol}${toMoney(
                                        Number(getTotal('subTotal', true, true)) *
                                          conversion,
                                        true,
                                      )}`}</strong>
                                    </h4>
                                  </>
                                ) : (
                                  <>
                                    <h4>
                                      <strong>{`$.${formatNumberWithCommas(
                                        getTotal('subTotal', true, false),
                                      )} / 
                            ${exchangeRate && exchangeRate.symbol}${toMoney(
                                        Number(getTotal('subTotal', true, true)) *
                                          conversion,
                                        true,
                                      )}`}</strong>
                                    </h4>
                                  </>
                                )
                              ) : (
                                <Money component="h4">
                                  <strong>{Number(getTotal('subTotal'))}</strong>
                                </Money>
                              )}
                            </div>
                          </Col>
                        )}
                        {tablet &&
                          type !== serviceType.PURCHASE &&
                          type !== serviceType.EXPENSES && (
                            <Col style={{ alignSelf: 'flex-end' }}>
                              <div className={'justify-center column'}>
                                <span>Descuento</span>
                                <Money component="h4">
                                  <strong>{Number(getTotal('discount'))}</strong>
                                </Money>
                              </div>
                            </Col>
                          )}
                        {tablet &&
                          !order &&
                          type === serviceType.PURCHASE &&
                          importation &&
                          currentCurrency.code !== 'USD' && (
                            <Col style={{ alignSelf: 'flex-end' }}>
                              <div className={'justify-center column'}>
                                <Switch
                                  topLabel
                                  name={'withExistence'}
                                  checked={activateLocalCurrency}
                                  onChange={e => {
                                    setActivateLocalCurrency(!activateLocalCurrency)

                                    if (!e.target.checked) {
                                      setExchangeRate(
                                        currenciesOwn.find(c => c.code === 'GTQ'),
                                      )
                                      let money = getExchangeRate('GTQ')
                                      setConversion(Number(money.exchange))
                                      selected.conversion = Number(money.exchange)
                                    } else {
                                      setExchangeRate(currentCurrency)
                                      setConversion(1)
                                      selected.conversion = Number(1)

                                      if (currentCurrency.code === 'USD') {
                                        setLocalCurrency(false)
                                      } else {
                                        setLocalCurrency(true)
                                      }
                                    }
                                    setSelected([...selected])
                                  }}
                                  label={`Moneda Local (${currentCurrency.symbol})`}
                                  info={'Manejar todo con moneda local'}
                                />
                              </div>
                            </Col>
                          )}
                        {tablet &&
                          !order &&
                          type === serviceType.PURCHASE &&
                          importation && (
                            <Col>
                              {!activateLocalCurrency && (
                                <div className={'justify-center column'}>
                                  <FormText
                                    label={'Tasa de conversión'}
                                    type={'number'}
                                    prepend={'Q'}
                                    value={conversion}
                                    onChange={({ target }) => {
                                      setConversion(Number(target.value))
                                      setSelected([...selected])
                                    }}
                                  />
                                </div>
                              )}
                            </Col>
                          )}
                      </Row>
                      {tablet
                        ? renderTable()
                        : itemsToSelect(
                            false,
                            selected,
                            'Productos seleccionados',
                            'No ha seleccionado ningún producto',
                            searchB,
                            setSearchB,
                          )}
                      {!tablet && (
                        <Col xl={12} lg={12} md={12}>
                          <Row
                            className={'container-buttons'}
                            style={{ paddingBottom: 2, display: 'flex' }}>
                            <Button
                              loading={loading || loadingInventory}
                              style={{ flex: 1 }}
                              icon={faPlus}
                              right
                              color={'accent'}
                              onClick={() => {
                                /*
                        if (type === serviceType.ORDERS && !warehouse.value) setError("Seleccione primero una bodega")
                        else {
                          selected.push({});
                          setSelected([...selected]);
                          setError(null);
                          dispatch(getInventoryWithPrices(warehouse.value, client ? client.latitude : 14.55,
                            client ? client.longitude : -90.55, false,
                            type, filters.withoutExistence, null, true, []))
                        } */
                                setMobile(true)
                              }}>
                              Agregar producto
                            </Button>
                          </Row>
                        </Col>
                      )}
                    </Card>
                  </Col>
                </Row>
              ) : (
                <div />
              )
            }}
          </Media>
        </div>

        <ItemCRUD
          show={cpShow}
          createdByTransaction={type}
          onHide={(created, itemCreated) => {
            setCPShow(false)
            if (created) {
              setProductId(itemCreated.id)
              dispatch(
                getExistenceSingleWarehouseWithPriceProducts(
                  null,
                  {},
                  currentCompany,
                  true,
                  false,
                  type,
                ),
              )
            }
          }}
        />

        <Modal show={mobile} centered size={'md'} onHide={() => setMobile(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Productos disponibles para agregar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {itemsToSelect(
              true,
              type === serviceType.ORDERS
                ? getOptions(inventory).filter(filterProduct).filter(checkFilter)
                : getOptions(inventory).filter(filterProduct),
              null,
              <div className={'d-flex'}>
                <Icon style={{ marginLeft: 5 }} icon={faKeyboard} />{' '}
                <Icon style={{ marginLeft: 5, marginRight: 5 }} icon={faArrowUp} />{' '}
                Escriba el nombre o SKU del producto para poder visualizarlo
              </div>,
              searchA,
              setSearchA,
            )}
          </Modal.Body>
        </Modal>

        <Modal show={showIVA} centered size={'md'} onHide={() => setShowIVA(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Configuración del IVA</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ marginTop: 5, display: 'flex' }}>
              <Switch
                id={'newIncludeIva'}
                cStyle={{ alignSelf: 'flex-end' }}
                name={'newIncludeIva'}
                checked={toSelect.newIncludeIva}
                onChange={({ target }) => {
                  setSelect({ ...toSelect, newIncludeIva: target.checked })
                  //changeQuantity(toSelect.quantity, toSelect, false);
                }}
                label={'IVA'}
                topLabel
              />
              <Select
                withoutLabel
                value={toSelect.phraseReference}
                onChange={value => {
                  setSelect({ ...toSelect, phraseReference: value })
                }}
                options={phrases}
                disabled={toSelect.newIncludeIva}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => {
                if (taxFree) updateTaxFree(toSelect, false)
                else updatePriceIVA(toSelect)
              }}
              icon={faPlusSquare}
              right>
              Actualizar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={toSelect.show}
          centered
          size={'md'}
          onHide={() => setSelect({ show: false })}>
          <Modal.Header closeButton>
            <Modal.Title>{toSelect.productName}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row>
              <Col xl={12} md={12} className={'space-between'}>
                <div className={'pi-body-title  left'}>Productor</div>
                <span>{toSelect.companyName}</span>
              </Col>
              {type === serviceType.ORDERS && (
                <>
                  <Col xl={12} md={12} className={'space-between'}>
                    <div className={'pi-body-title  left'}>Subtotal</div>
                    <Money component="span">{toSelect.subTotal}</Money>
                  </Col>
                  {allowDisableIva &&
                    toSelect.productId &&
                    type === serviceType.ORDERS && (
                      <Col xl={12} md={12} className={'space-between'}>
                        <div style={{ marginTop: 5, display: 'flex', width: '100%' }}>
                          <Switch
                            id={'includeIva'}
                            cStyle={{ alignSelf: 'flex-end' }}
                            name={'includeIva'}
                            checked={toSelect.includeIva}
                            onChange={({ target }) => {
                              updatePriceIVA(
                                {
                                  ...toSelect,
                                  newIncludeIva: target.checked,
                                  includeIva: !target.checked,
                                },
                                true,
                              )
                            }}
                            label={'IVA'}
                            topLabel
                          />
                          <Select
                            required={!toSelect.includeIva}
                            label={'Exento de IVA'}
                            value={toSelect.phraseReference}
                            options={phrases}
                            disabled={toSelect.includeIva}
                            onChange={value => {
                              setSelect({ ...toSelect, phraseReference: value })
                            }}
                          />
                        </div>
                      </Col>
                    )}
                  <Col xl={12} md={12}>
                    <FormText
                      label={'Cantidad'}
                      type={'number'}
                      value={toSelect.quantity}
                      prepend={
                        <Icon
                          icon={faMinus}
                          onClick={() =>
                            changeQuantity(
                              (toSelect.quantity ? parseInt(toSelect.quantity) : 0) - 1,
                              toSelect,
                              true,
                            )
                          }
                        />
                      }
                      append={
                        <Icon
                          icon={faPlus}
                          onClick={() =>
                            changeQuantity(
                              (toSelect.quantity ? parseInt(toSelect.quantity) : 0) + 1,
                              toSelect,
                              true,
                            )
                          }
                        />
                      }
                      onChange={({ target }) =>
                        changeQuantity(target.value, toSelect, true)
                      }
                    />
                  </Col>
                  {savePrice && toSelect.activeUpdatable ? (
                    <Col xl={12} md={12}>
                      <CustomCreate
                        label={'Precio'}
                        value={
                          toSelect.selectedPrice || {
                            value: toSelect.productPrice,
                            label: toSelect.productPrice,
                          }
                        }
                        textLabel={`Agregar precio ${currentCurrency.symbol}.`}
                        disabled={toSelect.add}
                        placeholder={'Buscar o seleccionar'}
                        options={toSelect.list.map(l => ({
                          value: Number(l.price),
                          label: `${l.alias} - ${toMoney(l.price)}`,
                        }))}
                        onCreateOption={value => {
                          if (!isNaN(value)) {
                            if (value < 0) value = 0
                            toSelect.price = value
                            toSelect.productPrice = value
                            toSelect.selectedPrice = {
                              value: Number(value),
                              label: toMoney(value),
                            }
                            toSelect.save = true

                            if (!toSelect.includeIva) {
                              updatePriceIVA(
                                {
                                  ...toSelect,
                                  includeIva: !toSelect.includeIva,
                                  newIncludeIva: toSelect.includeIva,
                                },
                                true,
                              )
                            } else changeQuantity(toSelect.quantity, toSelect, true)
                          }
                        }}
                        onChange={value => {
                          if (value) {
                            let comp = `${value.value || 0}`
                            if (comp.match(/[0-9]+/g)) {
                              if (value.value < 0)
                                value = {
                                  value: Number(value.value),
                                  label: toMoney(value.value),
                                }
                              toSelect.price = value.value
                              toSelect.productPrice = value.value
                              toSelect.selectedPrice = value
                              toSelect.save = false
                              if (!toSelect.includeIva) {
                                updatePriceIVA(
                                  {
                                    ...toSelect,
                                    includeIva: !toSelect.includeIva,
                                    newIncludeIva: toSelect.includeIva,
                                  },
                                  true,
                                )
                              } else changeQuantity(toSelect.quantity, toSelect, true)
                            }
                          }
                        }}
                      />
                    </Col>
                  ) : (
                    multiplePrices &&
                    toSelect.list &&
                    toSelect.list.length > 0 && (
                      <Col xl={12} md={12}>
                        <Select
                          label={'Precio'}
                          value={
                            toSelect.selectedPrice || {
                              value: Number(toSelect.productPrice),
                              label: toSelect.productPrice,
                            }
                          }
                          options={toSelect.list.map(l => ({
                            value: Number(l.price),
                            label: `${l.alias} - ${toMoney(l.price)}`,
                          }))}
                          onChange={value => {
                            toSelect.selectedPrice = value
                            changeQuantity(toSelect.quantity, toSelect, true)
                          }}
                        />
                      </Col>
                    )
                  )}
                  {toSelect.subProductData && (
                    <Col xl={12} md={12}>
                      <FormText
                        label={toSelect.subProductData.name}
                        type={'number'}
                        prepend={
                          <Icon
                            icon={faMinus}
                            onClick={() =>
                              changeSQuantity(
                                (toSelect.sQuantity ? parseInt(toSelect.sQuantity) : 0) -
                                  1,
                                toSelect,
                                true,
                              )
                            }
                          />
                        }
                        append={
                          <Icon
                            icon={faPlus}
                            onClick={() =>
                              changeSQuantity(
                                (toSelect.sQuantity ? parseInt(toSelect.sQuantity) : 0) +
                                  1,
                                toSelect,
                                true,
                              )
                            }
                          />
                        }
                        value={toSelect.sQuantity}
                        onChange={({ target }) =>
                          changeSQuantity(target.value, toSelect, true)
                        }
                      />
                    </Col>
                  )}
                  {!isGeneral ? (
                    <Col xl={12} md={12} className={'space-between'}>
                      <div style={{ marginTop: 5, display: 'flex', width: '100%' }}>
                        <Switch
                          disabled={isGeneral}
                          id={'discountPercent'}
                          cStyle={{ alignSelf: 'flex-end' }}
                          name={'checkDiscount'}
                          checked={toSelect.percentDiscount}
                          onChange={e =>
                            percentDiscount(
                              toSelect,
                              { label: '0%', value: 0 },
                              e.currentTarget.checked,
                            )
                          }
                          label={'%'}
                          topLabel
                        />
                        {toSelect.percentDiscount ? (
                          <Select
                            style={{ flex: 1 }}
                            value={toSelect.percent}
                            onChange={value => percentDiscount(toSelect, value, true)}
                            label={`Porcentaje de descuento Q.${formatNumberWithCommas(
                              toSelect.discount || 0,
                            )}`}
                            options={discounts}
                            error={toSelect.error}
                          />
                        ) : (
                          <FormText
                            disabled={isGeneral}
                            label={`Descuento (${toMoney(toSelect.maxDiscount)})`}
                            type={'number'}
                            value={toSelect.discount}
                            prepend={
                              <Icon
                                icon={faMinus}
                                onClick={() =>
                                  changeDiscount(
                                    (toSelect.discount
                                      ? parseInt(toSelect.discount)
                                      : 0) - 1,
                                    toSelect,
                                    true,
                                  )
                                }
                              />
                            }
                            append={
                              <Icon
                                icon={faPlus}
                                onClick={() =>
                                  changeDiscount(
                                    (toSelect.discount
                                      ? parseInt(toSelect.discount)
                                      : 0) + 1,
                                    toSelect,
                                    true,
                                  )
                                }
                              />
                            }
                            onChange={({ target }) =>
                              changeDiscount(target.value, toSelect, true)
                            }
                            error={toSelect.error}
                          />
                        )}
                      </div>
                    </Col>
                  ) : (
                    <></>
                  )}
                  <Col xl={12} md={12}>
                    <FormText
                      label={'Comentario'}
                      value={toSelect.commentary}
                      prepend={<Icon icon={faComment} />}
                      onChange={({ target }) =>
                        setSelect({ ...toSelect, commentary: target.value })
                      }
                      as={'textarea'}
                      rows={5}
                      max={1000}
                    />
                  </Col>
                </>
              )}
              {(type === serviceType.PURCHASE || type === serviceType.EXPENSES) &&
                !toSelect.onlySeries && (
                  <>
                    <Col xl={12} md={12} className={'space-between'}>
                      <div className={'pi-body-title  left'}>Precio Unitario</div>
                      <Money component="span">
                        {(toSelect.subTotal || 0) / (toSelect.quantity || 1)}
                      </Money>
                    </Col>
                    <Col xl={12} md={12}>
                      <FormText
                        label={'Cantidad'}
                        type={'number'}
                        value={toSelect.quantity}
                        prepend={
                          <Icon
                            icon={faMinus}
                            onClick={() =>
                              onChangeInput(
                                (toSelect.quantity ? parseInt(toSelect.quantity) : 0) - 1,
                                'quantity',
                              )
                            }
                          />
                        }
                        append={
                          <Icon
                            icon={faPlus}
                            onClick={() =>
                              onChangeInput(
                                (toSelect.quantity ? parseInt(toSelect.quantity) : 0) + 1,
                                'quantity',
                              )
                            }
                          />
                        }
                        onChange={({ target }) => onChangeInput(target.value, 'quantity')}
                      />
                    </Col>
                    <Col xl={12} md={12}>
                      <FormText
                        label={`Sub-total (${
                          activateLocalCurrency ? exchangeRate.symbol : '$'
                        })`}
                        type={'number'}
                        prepend={
                          <Icon
                            icon={faMinus}
                            onClick={() =>
                              onChangeInput(
                                (toSelect.subTotal ? parseInt(toSelect.subTotal) : 0) - 1,
                                'subTotal',
                              )
                            }
                          />
                        }
                        append={
                          <Icon
                            icon={faPlus}
                            onClick={() =>
                              onChangeInput(
                                (toSelect.subTotal ? parseInt(toSelect.subTotal) : 0) + 1,
                                'subTotal',
                              )
                            }
                          />
                        }
                        value={toSelect.subTotal}
                        required
                        onChange={({ target }) => onChangeInput(target.value, 'subTotal')}
                      />
                    </Col>
                    {importation && (
                      <Col xl={12} md={12}>
                        <FormText
                          label={`Costo de impuestos (${
                            activateLocalCurrency ? exchangeRate.symbol : '$'
                          })`}
                          type={'number'}
                          prepend={
                            <Icon
                              icon={faMinus}
                              onClick={() =>
                                onChangeInput(
                                  (toSelect.tax ? parseInt(toSelect.tax) : 0) - 1,
                                  'tax',
                                )
                              }
                            />
                          }
                          append={
                            <Icon
                              icon={faPlus}
                              onClick={() =>
                                onChangeInput(
                                  (toSelect.tax ? parseInt(toSelect.tax) : 0) + 1,
                                  'tax',
                                )
                              }
                            />
                          }
                          value={toSelect.tax}
                          required
                          onChange={({ target }) => onChangeInput(target.value, 'tax')}
                        />
                      </Col>
                    )}
                    {importation && (
                      <Col xl={12} md={12}>
                        <FormText
                          mt={0}
                          label={`Sub-total + impuestos en ${
                            exchangeRate !== undefined ? exchangeRate.symbol : ''
                          }.`}
                          value={
                            toSelect.customPrice ||
                            formatNumberWithCommas(
                              (Number(toSelect.subTotal) + Number(toSelect.tax || 0)) *
                                conversion,
                            )
                          }
                          prepend={
                            <Icon
                              icon={faMinus}
                              onClick={() =>
                                onChangeInput(
                                  (toSelect.customPrice
                                    ? parseInt(toSelect.customPrice)
                                    : 0) - 1,
                                  'customPrice',
                                )
                              }
                            />
                          }
                          append={
                            <Icon
                              icon={faPlus}
                              onClick={() =>
                                onChangeInput(
                                  (toSelect.customPrice
                                    ? parseInt(toSelect.customPrice)
                                    : 0) + 1,
                                  'customPrice',
                                )
                              }
                            />
                          }
                          type={'number'}
                          onChange={({ target }) =>
                            onChangeInput(target.value, 'customPrice')
                          }
                        />
                      </Col>
                    )}
                    {type === serviceType.PURCHASE && (
                      <Col xl={12} md={12}>
                        <CustomDate
                          style={{ position: 'relative' }}
                          label={'Fecha de Vencimiento'}
                          value={toSelect.expirationDate}
                          disabledDays={[]}
                          onDayChange={e => onChangeInput(e, 'expirationDate')}
                        />
                      </Col>
                    )}

                    {!importation && type === serviceType.PURCHASE && renderSeries()}
                  </>
                )}
              {type === serviceType.PURCHASE && toSelect.onlySeries && renderSeries()}
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Row className={'container-buttons'}>
              <Button
                onClick={() => {
                  if (toSelect.edit >= 0) selected[toSelect.edit] = toSelect
                  else selected.push(toSelect)
                  setSelected([...selected])
                  setSelect({})
                }}
                disabled={disabledOptions()}
                icon={faPlusSquare}
                right>
                Agregar
              </Button>
            </Row>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }

  const renderButton = () => {
    return (
      <>
        <Button
          color={'secondary'}
          icon={faWindowClose}
          right
          onClick={() => hide()}
          disabled={loadingInventory}>
          Cerrar
        </Button>
        <Button
          disabled={loadingInventory}
          color={'primary'}
          icon={faSave}
          right
          onClick={() => onSave(selected, warehouse)}>
          Guardar
        </Button>
      </>
    )
  }

  {
    /*
  document.addEventListener('keyup', (e) => {
    clearTimeout(intervalBarcode);
    if (e.key !== 'Enter')
      b += e.key;

    intervalBarcode = setTimeout(() => {
      setBarcodeValue(true);

      -- let totalCharacter = b.length / 32
      let index = 0;
      let barcode = '';
      for (let i = 0; i < totalCharacter; i++) {
        barcode += b[index];
        index += 32;
      } --

      -- dispatch(getInventoryWithPrices(
          warehouse.value, "", "", false,
          type, filters.withoutExistence, null, null, null, barcode
      ));--

      b = '';
    }, 1000);

  }, false);
  */
  }

  return (
    <div>
      {modal ? (
        <Modal
          show={action.open && !mobile}
          centered
          size={'xl'}
          onHide={() => undefined}>
          <Modal.Header>
            <Modal.Title>Detalle de venta</Modal.Title>
          </Modal.Header>
          <Modal.Body>{render()}</Modal.Body>
          <Modal.Footer>
            <Row className="container-buttons">{renderButton()}</Row>
          </Modal.Footer>
        </Modal>
      ) : (
        render()
      )}
      <Alert {...alert} />
    </div>
  )
}

export default SelectProducts

export const serviceType = {
  ORDERS: 1,
  WASTE: 2,
  PRODUCTION: 3,
  PURCHASE: 4,
  EXPENSES: 5,
}
